import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=6a6b6e8c&scoped=true"
import script from "./GlobalHeader.vue?vue&type=script&lang=ts"
export * from "./GlobalHeader.vue?vue&type=script&lang=ts"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=6a6b6e8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6b6e8c",
  null
  
)

export default component.exports